

export const setChallengeType = (type) => ({ type });